import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { NakedButton, rgba, useTooltip } from '@frontend/design-system';

export const OptOutIcon = () => {
  const { t } = useTranslation('schedule-quick-fill');
  const { tooltipProps, triggerProps, Tooltip } = useTooltip({ placement: 'top-end' });
  return (
    <>
      <NakedButton css={[iconButtonStyle, optOutIconButtonStyle]} {...triggerProps}>
        <Icon color='light' name='opt-out' size={12} />
      </NakedButton>
      <Tooltip {...tooltipProps}>{t('Opted Out')}</Tooltip>
    </>
  );
};

export const CalendarIcon = ({ tooltipText }: { tooltipText: string }) => {
  const { tooltipProps, triggerProps, Tooltip } = useTooltip({ placement: 'top-end' });

  return (
    <>
      <NakedButton css={[iconButtonStyle, calendarIconButtonStyle]} {...triggerProps}>
        <Icon color='primary' name='calendar' size={12} />
      </NakedButton>
      <Tooltip {...tooltipProps}>{tooltipText}</Tooltip>
    </>
  );
};

const iconButtonStyle = css({
  height: 16,
  width: 16,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: theme.borderRadius.small,
  transition: 'background 0.2s ease-in-out',
});

const calendarIconButtonStyle = css({
  background: rgba(theme.colors.primary50, 0.1),
  ':hover': {
    background: rgba(theme.colors.primary50, 0.25),
  },
});

const optOutIconButtonStyle = css({
  background: rgba(theme.colors.black, 0.05),
  ':hover': {
    background: rgba(theme.colors.black, 0.1),
  },
});
